import React from 'react';
import { Layout, Divider } from 'antd';
const { Content } = Layout;
/**
 * ContentComp
 * --
 */
const ContentComp = ({
  id = '',
  title = '',
  maxWidth = 500,
  height = null,
  minHeight = null,
  maxHeight = null,
  style = {},
  children,
  className = '',
  backgroundColor = '#FFFFFF',
  layout = false,
  padding = 15,
  fullWidth = false,
  borderRadius = 0,
  onClick = () => {},
}) => {
  /* RENDER */
  const view = (
    <Content
      id={id}
      className={className}
      style={{
        //   padding: '0 50px',
        width: '100%',
        maxWidth: fullWidth ? '100%' : maxWidth,
        margin: '0 auto',
        background: backgroundColor,
        // borderBottom: '1px solid #f1f1f1',
        padding,
        ...(borderRadius && { borderRadius }),
        ...(minHeight && { minHeight }),
        ...(maxHeight && { maxHeight }),
        ...(height && { height }),
        ...style,
      }}
      onClick={onClick}
    >
      {title && <Divider orientation="center">{title}</Divider>}
      {children}
    </Content>
  );
  return layout ? <Layout>{view}</Layout> : view;
};

export default ContentComp;
